/* eslint-disable react/prop-types */
import React from "react";
import { FormControlLabel, Switch } from "@mui/material";
import {
  onaudioendFunctionGet,
  onresultFunctionGet,
} from "../../speech_recognition/speech_recognition_common";
import useRecognizeConnect from "../../providers/RecognizeConnect/RecognizeConnect";
import { inputFocusCursor } from "../../providers/RecognizeConnect/recognize_connect_common";
import SpeechRecognize from "../../models/SpeechRecognize";

type RecognizeSwitchProps = {
  isSpeechRecognize: boolean;
};

const RecognizeSwitch = ({ isSpeechRecognize }: RecognizeSwitchProps) => {
  const { speechRecognize, setSpeechRecognize, setSpeechText, editTextRef } =
    useRecognizeConnect();

  const switchLabel = React.useMemo(
    () => (!isSpeechRecognize ? "SPEAK START" : "SPEAK STOP"),
    [isSpeechRecognize]
  );

  const actionSwitchChangeHandler = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const recognitionActive = event.target.checked;
    if (!recognitionActive) {
      if (speechRecognize !== null) {
        speechRecognize.stopRecognition();

        inputFocusCursor(editTextRef);
      }
      setSpeechRecognize(null);
    } else {
      const onresult = onresultFunctionGet(setSpeechText);
      const onaudioend = onaudioendFunctionGet(setSpeechRecognize);
      const speechRecogn = new SpeechRecognize({ onresult, onaudioend });
      setSpeechRecognize(speechRecogn);

      inputFocusCursor(editTextRef);
    }
  };

  return (
    <FormControlLabel
      control={
        <Switch
          onChange={actionSwitchChangeHandler}
          checked={isSpeechRecognize}
        />
      }
      label={switchLabel}
    />
  );
};

export default RecognizeSwitch;
